/*
  Fine delle promozioni a tempo (Cosmos Agency, giro 107, 15/10/2026).
  Ogni elemento con data-parrot-fino-al="<data ISO con fuso, es. 2026-10-25T23:59:59+01:00>" o "<secondi dal 1/1/1970>" sparisce
  (display:none) quando la data passa. Serve perché 'now' di Liquid vale «all'ultimo render» e la pagina può restare in cache
  (https://shopify.dev/docs/api/liquid/filters/date): la striscia verde delle card, la riga della barra nera e simili spariscono comunque.
*/
(() => {
  const fine = (valore) => (/^\d{9,11}$/.test(valore) ? Number(valore) * 1000 : Date.parse(valore));

  function controlla() {
    const ora = Date.now();
    for (const el of document.querySelectorAll('[data-parrot-fino-al]')) {
      const scadenza = fine(el.getAttribute('data-parrot-fino-al'));
      if (!Number.isNaN(scadenza) && ora > scadenza) {
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('aria-hidden', 'true');
      }
    }
  }

  controlla();
  setInterval(controlla, 5000);
  document.addEventListener('visibilitychange', controlla);
  window.addEventListener('pageshow', controlla);
  document.addEventListener('shopify:section:load', controlla);
})();
